var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6274 0 24 5.37258 24 12C23.9967 18.626 18.626 23.9967 12 24C5.37395 23.9967 0.00331054 18.626 0 12C0 5.37258 5.37258 0 12 0ZM8.24881 18.7431V9.37207H5.13281V18.7431H8.24881ZM19.4817 18.7429V13.3689C19.4817 10.4899 17.9437 9.15089 15.8947 9.15089C14.7438 9.10517 13.6624 9.7013 13.0867 10.6989V9.37189H9.97266C10.0147 10.2509 9.97266 18.7429 9.97266 18.7429H13.0867V13.5099C13.0739 13.2526 13.1078 12.9951 13.1867 12.7499C13.4242 12.069 14.0655 11.6121 14.7867 11.6099C15.9137 11.6099 16.3647 12.4689 16.3647 13.7279V18.7429H19.4817ZM6.71222 4.8523C6.25906 4.81456 5.81079 4.9682 5.47604 5.27597C5.14129 5.58375 4.95061 6.01756 4.95022 6.4723C4.94755 6.92052 5.13151 7.34964 5.45798 7.65676C5.78445 7.96389 6.224 8.12132 6.67122 8.0913H6.69122C7.14445 8.12962 7.59301 7.97635 7.92803 7.6687C8.26304 7.36105 8.45388 6.92714 8.45422 6.4723C8.45551 6.02065 8.26819 5.58897 7.93745 5.28139C7.60671 4.97382 7.16259 4.81828 6.71222 4.8523Z",
    fill: "#00ABE8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.6ce4132282d0cfb9c0fbb1485f046b88.svg";
export { ForwardRef as ReactComponent };